import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InfoIcon, Typography } from '@dev/ee-components';
import { TimingOptionEnum } from '@dev/ee-api/ee-api-models';

import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { IconInfoWrapper } from '../styled';

const TimingOptionInfoWrapper = styled.div`
    display: flex;
    margin-top: 40px;
`;

export const TimingOptionInfo = (): JSX.Element => {
    const { t } = useTranslation();
    const { campaign } = useSelector(getCampainCreatorStore);
    const timingOpt = campaign.Options.TimingOption;

    return (
        <TimingOptionInfoWrapper>
            <IconInfoWrapper>
                <InfoIcon />
            </IconInfoWrapper>
            <Typography variant="body1" bodyVariant="onPaper">
                {timingOpt === TimingOptionEnum.EngagedContactFirst
                    ? t('engagedcontactfirst_info')
                    : t('optimalopentime_info')}
            </Typography>
        </TimingOptionInfoWrapper>
    );
};
